module.exports = __webpack_public_path__ + "static/media/jump-page-es.99dc8a17.png";